"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapNestLogger = exports.isNestLogger = exports.isSillyLogger = void 0;
function isSillyLogger(logger) {
    return typeof (logger === null || logger === void 0 ? void 0 : logger['silly']) !== 'undefined';
}
exports.isSillyLogger = isSillyLogger;
function isNestLogger(logger) {
    return typeof (logger === null || logger === void 0 ? void 0 : logger['verbose']) !== 'undefined';
}
exports.isNestLogger = isNestLogger;
function wrapNestLogger(logger) {
    return {
        silly: (...msg) => logger.verbose(msg.join(', ')),
    };
}
exports.wrapNestLogger = wrapNestLogger;
//# sourceMappingURL=logger.js.map